module.exports = __webpack_public_path__ + "img/selection_management_empty.915d0172.png";